import Breadcrumbs from '../components/Breadcrumbs';
import OutletCard from '../components/OutletCard';
import { OUTLETS } from '../data/site';

export default function LokasiPage() {
  return (
    <>
      <section className="bg-[#F5EFE6] border-b border-[#E2D3BE]">
        <div className="mx-auto max-w-6xl px-5 py-12 sm:py-16">
          <Breadcrumbs items={[{ name: 'Lokasi', path: '/lokasi/' }]} />
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#2B1B12] tracking-tight mt-6">
            Lokasi Outlet
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#6E6259]">
            Ayam Goreng Widuran hadir di dua titik di Kota Solo dan satu cabang di Denpasar, Bali.
            Gunakan tombol petunjuk arah untuk navigasi langsung melalui Google Maps.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-20">
        <div className="grid gap-6 lg:grid-cols-3">
          {OUTLETS.map((o) => (
            <OutletCard key={o.id} outlet={o} />
          ))}
        </div>

        <div data-testid="lokasi-hours-note" className="mt-12 rounded-lg border border-[#E2D3BE] bg-[#F5EFE6] p-6 max-w-3xl">
          <h2 className="font-pricemono text-xs font-semibold tracking-widest uppercase text-[#8C4A11]">
            Catatan Jam Operasional
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-[#6E6259]">
            Outlet utama Widuran (Jl. Sutan Syahrir) umumnya buka setiap hari mulai pagi sekitar
            pukul 07.00 WIB hingga sore. Jam operasional setiap outlet dapat berubah pada hari
            tertentu — silakan pantau pengumuman di Instagram resmi kami sebelum berkunjung.
          </p>
        </div>
      </section>
    </>
  );
}
